import { dynamicImport } from '@core/helpers'
import { ROUTES } from '@router'

const ModelsComparisonHome = () =>
  dynamicImport(import('./pages/ModelsComparisonHome/ModelsComparisonHome.vue'))
const ModelsComparisonResults = () =>
  dynamicImport(
    import('./pages/ModelsComparisonResults/ModelsComparisonResults.vue'),
  )
const ModelsComparisonSearch = () =>
  dynamicImport(
    import('./pages/ModelsComparisonSearch/ModelsComparisonSearch.vue'),
  )

export default ({ config, country }) => {
  const isNewModelsComparisonActiveInCountry =
    config.FF_NEW_MODELS_COMPARISON_ACTIVE_IN_COUNTRY?.includes(country)
  const isHomeComparisonEnabledInCountry =
    config.FF_MODELS_COMPARISON_HOME_ENABLED_IN_COUNTRY?.includes(country)

  const HomeComparisonRoute = isHomeComparisonEnabledInCountry
    ? [
        {
          name: ROUTES.MODELS_COMPARISON.HOME,
          path: 'compare/home',
          component: ModelsComparisonHome,
        },
      ]
    : []

  return isNewModelsComparisonActiveInCountry
    ? [
        ...HomeComparisonRoute,
        {
          name: ROUTES.MODELS_COMPARISON.COMPARISON_RESULTS,
          path: 'compare/:productA/:productB',
          component: ModelsComparisonResults,
        },
        {
          name: ROUTES.MODELS_COMPARISON.CATEGORY,
          path: 'compare/:category',
          component: ModelsComparisonSearch,
        },
      ]
    : []
}
